import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface EligibleItem {
  fn210_01: string;
  fn210_11: string;
  fn210_15: string;
  fn210_80: string;
  fn210_26: string;
  fn210_36: string;
  fn210_90: number;
}

export interface SearchResponse {
  items: EligibleItem[];
  total: number;
}

export interface ExecuteResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ExecuteResponse {
  results: ExecuteResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface SearchFilter {
  startNo: string;
  endNo: string;
}

// ============================================================
// API methods
// ============================================================

export const n5p1Api = {
  // POST /api/n5p1/search
  async search(filter: SearchFilter): Promise<SearchResponse> {
    const res = await apiClient.post('/api/n5p1/search', {
      start_no: filter.startNo,
      end_no: filter.endNo,
    });
    return res.data;
  },

  // POST /api/n5p1/execute
  // confirmed:true mirrors the Popconfirm the user already went through in
  // N5P1Form (FoxPro's PWU016F2 "請確認沖銷本資料!" dialog) — the backend
  // requires it (BR-V06, backend/modules/n5p1/validator/validator.go).
  async execute(docNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/n5p1/execute', { doc_nos: docNos, confirmed: true });
    return res.data;
  },
};
